import React from 'react';
import { useCarNameLabel } from '../../../../utils/carNames';
import CallLink from '../../../common/CallLink';
import PageLoader from '../../../common/PageLoader';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'react-image-gallery/styles/css/image-gallery.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-image-gallery/styles/css/image-gallery.css';
import { CommonBanner } from '../CommonBanner';
import { externalUrl } from "../../../../utils/externalUrl";
import { GET_ONE_CARDEALER_LIST } from '../../../../Redux/Actions/ActionType';
import MapModalForView from '../../../common/Modal/MapModalForView';
import { useTranslation } from 'react-i18next';
import { saveAItem, removeSavedItem, getSavedItems } from '../../../../Redux/Actions/UserAction';
import Swal from 'sweetalert2';
import { shareItem } from '../../../../utils/shareItem';
import { buildSavedIdSet, findSavedItemId } from '../../../../utils/savedItems';
import { pickCarImage } from '../../../../utils/pickCarImage';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};

const defaultImages = [
  {
    original: 'assets/images/service-provider/car-dealers/banner-a.jpg',
  },
];

const openStatus = ['OPEN', 'مفتوح'];

export default function CarDealersDetails() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  
  // Get current language for RTL support
  const isRTL = i18n.language === 'ar';
  /* [CF 2026-08-17 #11.1] The model is free text with no Arabic on the
     row; look it up from the model master. See utils/carNames.js */
  const nameLabel = useCarNameLabel(isRTL);
  
  // Function to detect Arabic text content
  const hasArabicText = (text) => {
    if (!text) return false;
    const arabicRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
    return arabicRegex.test(text);
  };
  
  // Align free text by the SITE/UI language, not the content language: in
  // English mode everything left-aligns (matching the left-aligned section
  // titles) even when a vendor wrote the text in Arabic; in Arabic mode it
  // right-aligns. The Arabic characters still shape/join correctly within the
  // line — only the block alignment follows the UI.
  // eslint-disable-next-line no-unused-vars
  const getTextAlign = (text) => (isRTL ? 'right' : 'left');

  // Pick the label for the active UI language (English name in English mode,
  // Arabic in Arabic mode), falling back to whichever exists.
  const L = (en, ar) => (isRTL ? ar || en : en || ar);
  const { carDealerId } = useParams();
  const singleData = useSelector(
    (state) => state.home?.OneCarDealerDetailList?.[0]
  );
  const [mapModalOpen, setMapModalOpen] = useState(false);

  const savedItemsList = useSelector((state) => state?.home?.savedItemsList);
  const savedIdSet = buildSavedIdSet(savedItemsList);
  const [savedOverride, setSavedOverride] = useState({});
  const isSaved = (id) =>
    savedOverride[id] !== undefined ? savedOverride[id] : savedIdSet.has(String(id));

  const onHandleSave = (carId) => {
    // Check if user is logged in
    const isLoggedIn = sessionStorage.getItem('loged_In') === 'true';
    
    if (!isLoggedIn) {
      Swal.fire({
        title: 'Please Login to Save',
        text: 'You need to be logged in to save this car. Please login first.',
        icon: 'warning',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Login',
        showCancelButton: true,
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          // Redirect to login page
          window.location.href = '#/login';
        }
      });
      return;
    }

    // User is logged in — optimistic toggle, no reload.
    const currentlySaved = isSaved(carId);
    setSavedOverride((prev) => ({ ...prev, [carId]: !currentlySaved }));
    if (currentlySaved) {
      const savedItemId = findSavedItemId(savedItemsList, carId);
      if (savedItemId) dispatch(removeSavedItem({ savedItemId }));
    } else {
      dispatch(saveAItem({ carId }));
    }
  };

  useEffect(() => {
    dispatch(getSavedItems());
  }, [dispatch]);

  useEffect(() => {
    const fetchOneCarDealerDetail = async (data) => {
      var object = { carDealerId };
      console.log('this is fatch ondata ', object);
      let query = '';
      Object.keys(object).forEach((key) => {
        console.log('this is object key', key);
        query += key + '=' + object[key] + '&';
      });
      query = query.slice(0, -1);
      console.log('this is the,', query);
      try {
        // console.log('fetch data part', data);
        axios
          .get(
            `https://api.carsavenue.com/api/carDealer/listing` +
              '?' +
              query,
            config
          )
          .then((res) => {
            console.log('heeee<<<<', res);
            dispatch({
              type: GET_ONE_CARDEALER_LIST,
              payload: res.data.response.data,
            });

            // setgarageDataDetail(res);

            console.log('heeee<<<<', res);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        // Swal.fire('Incorrect Credentials', '', 'error');
      }
    };
    if (carDealerId && carDealerId !== '')
      fetchOneCarDealerDetail({ carDealerId });
    // console.log('home data', garageDataDetail);
  }, [carDealerId, dispatch]);

  if (!singleData) {
    return (
      <>
        {/* <h2>dsdasdfasdf</h2> */}
        <div
          className="text-center text-warning"
          const
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <PageLoader /> <br />
        </div>
      </>
    );
  }

  console.log('carDealerDetailList', singleData);

  //Business Media Data, LOGO, BANNER
  const logoData = singleData?.businessMedia?.find(
    (item) => item.mediaType === 'LOGO'
  );

  let bannerImages = defaultImages;

  if (singleData?.businessMedia && singleData.businessMedia.length > 0) {
    const mediaImages = singleData.businessMedia
      .filter(
        (mediaItem) =>
          mediaItem?.media?.path &&
          (mediaItem.mediaType === 'MAIN_BANNER' ||
            mediaItem.mediaType === 'BANNER')
      )
      .sort(
        (a, b) =>
          (a.mediaType === 'MAIN_BANNER' ? 0 : 1) -
          (b.mediaType === 'MAIN_BANNER' ? 0 : 1)
      )
      .map((mediaItem) => ({
        original: mediaItem.media.path,
        thumbnail: mediaItem.media.path,
      }));

    if (mediaImages.length > 0) {
      bannerImages = mediaImages;
    }
  }

  //Business Calendar
  const businessCalendar =
    typeof singleData?.calendar === 'string'
      ? JSON.parse(singleData?.calendar)
      : singleData?.calendar;
  const now = new Date();
  const currentDay = now
    .toLocaleString('en-us', { weekday: 'long' })
    .toUpperCase(); // "MONDAY"

  const currentTime = now.getHours() * 60 + now.getMinutes();

  const timeToMinutes = (timeStr) => {
    const [time, period] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (period === 'PM' && hours < 12) hours += 12;
    if (period === 'AM' && hours === 12) hours -= 12;
    return hours * 60 + minutes;
  };

  let isOpen = false;
  let nextActionTime = ''; // Time for the next action

  const todaySchedule = (businessCalendar || {})[currentDay];

  if (todaySchedule) {
    const { status, openTime, endTime } = todaySchedule;

    if (status === 'مفتوح' || status === 'OPEN') {
      // "Open" status
      const openMinutes = timeToMinutes(openTime);
      const closeMinutes = timeToMinutes(endTime);

      if (currentTime >= openMinutes && currentTime <= closeMinutes) {
        isOpen = true;
        nextActionTime = endTime; // Display closing time
      } else if (currentTime < openMinutes) {
        isOpen = false;
        nextActionTime = openTime; // Display opening time
      } else {
        isOpen = false;
        nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display next day's opening time if closed
      }
    } else {
      isOpen = false;
      nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display opening time if closed
    }
  }

  //Location Data
  const gpsData =
    typeof singleData?.gps === 'string'
      ? JSON.parse(singleData?.gps)
      : singleData?.gps;
  const lat = parseFloat((gpsData || {}).lat);
  const lng = parseFloat((gpsData || {}).long);

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  //Social Media Data
  const socialMediaData =
    typeof singleData?.socialMedia === 'string'
      ? JSON.parse(singleData?.socialMedia)
      : singleData?.socialMedia;

  return (
    <div>
      <div class="user-banner">
        <CommonBanner bannerImages={bannerImages} />

        <div class="user-logo-holder">
          <div class="container">
            <div class="user-logo-holder-wrap">
              <div class="row align-items-center justify-content-between">
                <div class="col-12 col-sm-12 col-md-6 mb-3 mb-sm-3 mb-md-0">
                  <div class="row align-items-center">
                    <img
                      src={logoData?.media?.path || ''}
                      alt=""
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          'assets/images/service-provider/car-dealers/logo.jpg';
                      }}
                      className="max-w-2 max-h-2 rounded-full"
                      style={{
                        width: '140px',
                        height: '140px',
                        objectFit: 'contain',
                        backgroundColor: '#fff',
                      }}
                    />

                    <div class="col-8 col-sm-8 col-md-auto">
                      <h5 class="mb-3">
                        {singleData?.carDealerName} {singleData?.category}
                      </h5>
                      <ul class="list-inline mb-0 wpm">
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Calendar"
                        >
                          <a
                            href="javascript:void(0);"
                            data-toggle="modal"
                            data-target="#calendar-modal"
                          >
                            <i class="far fa-calendar-alt"></i>
                          </a>
                        </li>

                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Whatsapp"
                        >
                          <a
                            target="_blank"
                            href={`https://wa.me/${`${singleData?.whatsAppNumberCountryCode}${singleData?.whatsAppNumber}`.replace(/\D/g, '')}`}
                          >
                            <i class="fab fa-whatsapp"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Call"
                        >
                          {/* [CF 2026-08-17 #7/V4] Was a single tel: link built
                              from `mobileNumber`, so a dealer with several
                              numbers only ever offered the first. */}
                          <CallLink record={singleData}>
                            <i class="fas fa-phone"></i>
                          </CallLink>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Location Map"
                        >
                          <a href="javascript:void(0);" onClick={handleOpenMap}>
                            <i class="fas fa-map-marker-alt"></i>
                          </a>
                          <MapModalForView
                            open={mapModalOpen}
                            handleClose={handleCloseMap}
                            currentLocation={{
                              lat: lat,
                              long: lng,
                            }}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-12 col-md-auto">
                  {(isOpen || (nextActionTime && `${nextActionTime}`.trim() !== '')) && (
                    <p class="mb-3">
                    <span class={isOpen ? 'open-time' : 'close-time'}>
                      {isOpen ? t('Open Now') : t('Close Now')}
                    </span>{' '}
                    |{' '}
                    <span class={isOpen ? 'close-time' : 'open-time'}>
                      {isOpen
                        ? `${t('Closes at')} ${nextActionTime}`
                        : `${t('Open at')} ${nextActionTime}`}
                    </span>
                  </p>
                  )}
                  <ul className="list-inline mb-0">
                    {singleData?.website && (
                      <li className="list-inline-item">
                        <a
                          href={externalUrl(singleData?.website)}
                          target="_blank"
                          rel="noreferrer"
                          title="Website"
                        >
                          <i
                            className="fas fa-globe"
                            style={{ fontSize: '24px', color: '#0e76a8', verticalAlign: 'middle' }}
                          ></i>
                        </a>
                      </li>
                    )}
                    {socialMediaData?.INSTAGRAM && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.INSTAGRAM)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/instagram.png"
                            alt="Instagram"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.FACEBOOK && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.FACEBOOK)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/facebook.png"
                            alt="Facebook"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.TWITTER && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.TWITTER)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/twitter.png"
                            alt="Twitter"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.LINKEDIN && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.LINKEDIN)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/linkedin.png"
                            alt="Linkedin"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.YOUTUBE && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.YOUTUBE)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/youtube.png"
                            alt="Youtube"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.SNAPCHAT && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.SNAPCHAT)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/snapchat.png"
                            alt="Snapchat"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.GOOGLEPLUS && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.GOOGLEPLUS)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/google-plus.png"
                            alt="Google Plus"
                          />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>

              {/* <!-- CALENDAR  MODAL --> */}
              <div
                class="modal fade"
                id="calendar-modal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">{t('Timing')}</h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table class="table table-bordered table-striped">
                        <tbody>
                          <tr>
                            <td scope="col">{t('Day')}</td>
                            <td scope="col">{t('Open')}</td>
                            <td scope="col">{t('Close')}</td>
                          </tr>
                          {[
                            'SUNDAY',
                            'MONDAY',
                            'TUESDAY',
                            'WEDNESDAY',
                            'THURSDAY',
                            'FRIDAY',
                            'SATURDAY',
                          ].map((day) => {
                            const status = openStatus.includes(
                              businessCalendar?.[day]?.status
                            );

                            return status ? (
                              <tr>
                                <td scope="col">{t(day)}</td>
                                <td scope="col">
                                  {businessCalendar?.[day]?.openTime}
                                </td>
                                <td scope="col">
                                  {businessCalendar?.[day]?.endTime}
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td scope="col">{t(day)}</td>
                                <td scope="col">{t('Closed')}</td>
                                <td scope="col">{t('Closed')}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        {t('Close')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- CALENDAR  MODAL --> */}
            </div>
          </div>
        </div>
      </div>
      <div class="main-content-area">
        <div class="container">
          <h5 className="cav-section-title">{t('About Us')}</h5>
          {singleData?.about?.split('\n').map((line, index) => (
            <p key={index} style={{ textAlign: getTextAlign(line) }}>{line}</p>
          ))}
          {/* [CF-5] Website moved up to an icon beside the social icons. */}
          <h5 className="cav-section-title">{t('Cars')}</h5>

          <div class="row">
            {singleData?.car !== undefined ? (
              singleData?.car.map((item, i) => {
                // [CF 2026-07-28] Client: cars here showed the wrong picture.
                // This took carMedia[0] — whichever image happened to be stored
                // first, often an interior shot or a document — instead of the
                // car's primary photo. Prefer MAIN_BANNER, the same order the
                // app and the detail pages use, and only then fall back.
                const carImageFirst = pickCarImage(item?.carMedia);
                return (
                  <React.Fragment key={item?.carId || i}>
                    <div class="col-6 col-sm-6 col-md-4 col-lg-3 mb-4">
                      <div class="user-car-dealers-wrap">
                        <div class="line-a">
                          <Link
                            // to="/user-car-dealers-details-in"

                            to={`/user-car-dealers-details-in/${item?.carId}`}
                          >
                            <img
                              style={{
                                width: '100%',
                                height: '200px',
                                borderRadius: '10px',
                                objectFit: 'cover',
                                display: 'block',
                              }}
                              src={
                                carImageFirst ||
                                'assets/images/user/car-dealers/a.jpg'
                              }
                              alt=""
                              class="img-fluid"
                            />
                          </Link>
                        </div>
                        <div class="line-b">
                          {/* Brand + Save/Share — one aligned row */}
                          <div className="cav-card-row">
                            <div class="line-ba">{L(item?.brand?.name, item?.brand?.nameAr) || nameLabel(item?.carName)}</div>
                            <div className="cav-card-actions">
                              <button
                                onClick={() => onHandleSave(item?.carId)}
                                title="Save"
                                class="ss-btn"
                                style={{ cursor: 'pointer', background: 'none', border: 'none', color: isSaved(item?.carId) ? '#FFC400' : 'inherit', padding: 0, fontSize: 'inherit' }}
                              >
                                <i class={isSaved(item?.carId) ? 'fas fa-heart' : 'far fa-heart'}></i>
                              </button>
                              <a
                                href="#"
                                onClick={(e) =>
                                  shareItem(e, `/user-car-dealers-details-in/${item?.carId}`, item?.carName)
                                }
                                title="Share"
                                class="ss-btn"
                              >
                                <i class="far fa-share-square"></i>
                              </a>
                            </div>
                          </div>
                          {/* Model + year — aligned to the same two columns */}
                          <div className="cav-card-row line-bb">
                            <span>{nameLabel(item?.carModel)}</span>
                            <span>{item?.modelYear?.modelYear}</span>
                          </div>
                        </div>
                        <div class="line-c">
                          <div className="cav-card-row">
                            <span>{item?.kilometerDriven} KM</span>
                            <span>KD {item?.price}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })
            ) : (
              <div
                className="text-center text-warning"
                const
                style={{
                  position: 'fixed',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              >
                <PageLoader /> <br />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
